var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"drop"}},[(_vm.visible)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-content"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }